/* unplugin-vue-components disabled */import script from "./RedManage.vue?vue&type=script&setup=true&lang=js"
export * from "./RedManage.vue?vue&type=script&setup=true&lang=js"

import "./RedManage.vue?vue&type=style&index=0&id=2a687cc4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a687cc4"]])

export default __exports__